import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Spin,
  Select,
  Button,
  Tag,
  Drawer,
  Tooltip,
  Grid,
  Input,
  Checkbox,
  InputNumber,
  message,
  Radio,
} from "antd";
import React, { useState, useMemo, useCallback, useEffect } from "react";
import MotionHoc from "../../../utils/MotionHoc";
import {
  SearchOutlined,
  FilterOutlined,
  ReloadOutlined,
  DownSquareOutlined,
  UpSquareOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import DateCustom from "../../../hook/DateCustom";
import CurrencyFormat from "../../../hook/CurrencyFormat";
import {
  GET_CEO_CHECK_MAIN_STATUS,
  HEADERS_EXPORT,
  HEADERS_EXPORT_BEN,
  POST_CEO_CHECK_CONTNO_MISS_CALL,
  POST_CEO_CHECK_SUMMARY_MISS_CALL,
} from "../../API/apiUrls";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  LabelList,
} from "recharts";
import { currencyFormatOne } from "../closingBalance/modelFormat/Format";
import LoadLawyers from "../../../hook/LoadLawyers";
import { ExportSimpleContractList } from "./report excel/MainSumaryExport";

const { Option } = Select;
const userCompany = localStorage.getItem("COMPANY_ID");

// =====================================================
// Constants
// =====================================================

const SCHEME_TYPE_OPTIONS =
  userCompany === "3"
    ? [
        { value: "rpsl", label: "PLOAN" },
        { value: "vsfhp", label: "Smart Vat" },
        { value: "lsfhp", label: "Smart Loan" },
        { value: "tsfhp", label: "Smart HP" },
        { value: "2", label: "ทั้งหมดเว้น PLOAN" },
        { value: "all", label: "ทุกสัญญา" },
      ]
    : [
        { value: "lsfhp", label: "สัญญา 1" },
        { value: "vsfhp", label: "สัญญา 2" },
        { value: "sfhp", label: "สัญญา 8" },
        { value: "psfhp", label: "สัญญา 3 (เก่า)" },
        { value: "rpsl", label: "สัญญา 3 (ใหม่)" },
        { value: "1", label: "ทั้งหมดเว้น PLOAN" },
        { value: "all", label: "ทุกสัญญา" },
      ];

const ALL_SCHEME_TYPES =
  userCompany === "3"
    ? ["rpsl", "vsfhp", "lsfhp", "tsfhp"]
    : ["lsfhp", "vsfhp", "sfhp", "psfhp", "rpsl"];

const STATUS_OPTIONS = [
  { value: 99, icon: "🗂️", label: "ทั้งหมด", color: "default" },
  { value: 2, icon: "📝", label: "สร้างคำฟ้อง", color: "orange" },
  { value: 3, icon: "⏳", label: "รอพิพากษา", color: "blue" },
  { value: 4, icon: "⚖️", label: "พิพากษา", color: "purple" },
  { value: 5, icon: "✍️", label: "ทำยอม", color: "green" },
  { value: 6, icon: "🏁", label: "คดีถึงที่สุด", color: "default" },
  { value: 7, icon: "🔍", label: "สืบทรัพย์หลังฟ้อง", color: "cyan" },
  { value: 8, icon: "⚡", label: "บังคับคดี", color: "red" },
  { value: 9, icon: "💼", label: "เจรจาทรัพย์", color: "gold" },
  { value: 10, icon: "🏷️", label: "ขายทรัพย์", color: "lime" },
  { value: 11, icon: "✅", label: "ปิดบัญชี", color: "green" },
  { value: 12, icon: "⏰", label: "หมดอายุความ", color: "default" },
  { value: 13, icon: "❌", label: "ถอนฟ้อง", color: "volcano" },
  { value: 14, icon: "💀", label: "ลูกหนี้สูญ", color: "default" },
  { value: 15, icon: "🔎", label: "สืบทรัพย์ก่อนฟ้อง", color: "geekblue" },
  { value: 16, icon: "📊", label: "การตลาดเจรจา", color: "magenta" },
];

// ลำดับสถานะสำหรับ Stacked Bar Chart
const STATUS_ORDER = [
  "ยังไม่ส่งทนาย",
  "สร้างคำฟ้อง",
  "รอพิพากษา",
  "พิพากษา",
  "ถอนฟ้อง",
  "ทำยอม",
  "บังคับคดี",
  "ขายทรัพย์",
];

const PROCESS_STATUS_OPTIONS = [
  { value: 1, label: "รอดำเนินการ", color: "orange", icon: "⏳" },
  { value: 2, label: "กำลังดำเนินการ", color: "blue", icon: "🔄" },
  { value: 3, label: "สำเร็จ", color: "green", icon: "✅" },
  { value: 4, label: "ไม่สำเร็จ", color: "red", icon: "❌" },
];

const STATUS_OPTIONS_SELECT = [
  { value: 99, icon: "🗂️", label: "ทั้งหมด", color: "default" },
  { value: null, icon: "❌", label: "ยังไม่ส่งทนาย", color: "gray" },
  { value: 2, icon: "📝", label: "สร้างคำฟ้อง", color: "orange" },
  { value: 3, icon: "⏳", label: "รอพิพากษา", color: "blue" },
  { value: 4, icon: "⚖️", label: "พิพากษา", color: "purple" },
  { value: 5, icon: "✍️", label: "ทำยอม", color: "green" },
  { value: 6, icon: "🏁", label: "คดีถึงที่สุด", color: "default" },
  { value: 8, icon: "⚡", label: "บังคับคดี", color: "red" },
  { value: 10, icon: "🏷️", label: "ขายทรัพย์", color: "lime" },
  { value: 11, icon: "✅", label: "ปิดบัญชี", color: "green" },
  { value: 12, icon: "⏰", label: "หมดอายุความ", color: "default" },
  { value: 13, icon: "❌", label: "ถอนฟ้อง", color: "volcano" },
  { value: 14, icon: "💀", label: "ลูกหนี้สูญ", color: "default" },
];

const OPTIONS_STATUS_INVESTIGATION = [
  { value: 0, label: "ไม่เจอทรัพย์" },
  { value: 1, label: "เจอทรัพย์" },
  { value: 2, label: "อายัดเงินได้" },
];

const CHART_COLORS = {
  orange: "#fa8c16",
  blue: "#1890ff",
  purple: "#722ed1",
  green: "#52c41a",
  default: "#d9d9d9",
  cyan: "#13c2c2",
  red: "#f5222d",
  gold: "#faad14",
  lime: "#a0d911",
  volcano: "#fa541c",
  geekblue: "#2f54eb",
  magenta: "#eb2f96",
  gray: "#8c8c8c",
};

// =====================================================
// Helper Functions
// =====================================================

const getLatestInvestigationLog = (investigationLogList) => {
  if (
    !Array.isArray(investigationLogList) ||
    investigationLogList.length === 0
  ) {
    return null;
  }

  return investigationLogList.reduce((latest, current) => {
    if (!latest) return current;

    const latestDate = new Date(latest.created_date);
    const currentDate = new Date(current.created_date);

    return currentDate > latestDate ? current : latest;
  }, null);
};

const getLawyerName = (userId, lawyersList) => {
  if (!userId || !lawyersList) return userId || "-";
  const lawyer = lawyersList.find((item) => item.id === userId);
  return lawyer ? lawyer.NNAME : userId;
};

const useChartData = (data, type) => {
  return useMemo(() => {
    if (!Array.isArray(data) || data.length === 0) {
      return { pieData: [] };
    }

    const statusMap = new Map();
    let noDataCount = 0;

    data.forEach((item) => {
      const statusId = !type
        ? item?.dataLawyer?.MAIN_STATUS_ID
        : item.MAIN_STATUS_ID;

      if (!statusId && statusId !== 0) {
        noDataCount += 1;
        return;
      }

      const statusInfo = STATUS_OPTIONS.find((s) => s.value === statusId);
      if (!statusInfo || statusId === 99) return;

      const existing = statusMap.get(statusId) || {
        statusId,
        label: statusInfo.label,
        icon: statusInfo.icon,
        color: statusInfo.color,
        count: 0,
        totalBalance: 0,
        totalRemaining: 0,
      };

      existing.count += 1;
      existing.totalBalance += item.BALANC || 0;
      existing.totalRemaining += (item.BALANC || 0) - (item.SMPAY || 0);
      statusMap.set(statusId, existing);
    });

    const chartData = Array.from(statusMap.values()).sort(
      (a, b) => b.count - a.count
    );

    if (noDataCount > 0) {
      chartData.push({
        statusId: null,
        label: "ยังไม่ส่งทนาย",
        icon: "❌",
        color: "gray",
        count: noDataCount,
        totalBalance: 0,
        totalRemaining: 0,
      });
    }

    const pieData = chartData.map((item) => ({
      name: item.label,
      value: item.count,
      icon: item.icon,
      color: item.color,
    }));

    return { pieData };
  }, [data]);
};

// =====================================================
// Tooltip Components
// =====================================================

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: "white",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        }}
      >
        <p style={{ margin: 0, fontWeight: "bold" }}>{payload[0].name}</p>
        <p style={{ margin: "4px 0 0 0", color: "#666" }}>
          จำนวน: <strong>{payload[0].value}</strong> สัญญา
        </p>
        {payload[0].payload.percent && (
          <p style={{ margin: "4px 0 0 0", color: "#666" }}>
            สัดส่วน:{" "}
            <strong>{(payload[0].payload.percent * 100).toFixed(2)}%</strong>
          </p>
        )}
      </div>
    );
  }
  return null;
};

// Stacked Bar Chart Tooltip - ปรับปรุงใหม่
const CustomStackedBarTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const total = payload.reduce((sum, entry) => sum + entry.value, 0);

    return (
      <div
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.98)",
          padding: "16px",
          border: "2px solid #1890ff",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          maxWidth: "280px",
        }}
      >
        <p
          style={{
            margin: 0,
            fontWeight: "bold",
            marginBottom: "12px",
            fontSize: "14px",
            color: "#1890ff",
            borderBottom: "2px solid #e8e8e8",
            paddingBottom: "8px",
          }}
        >
          {label}
        </p>
        <p
          style={{
            margin: "8px 0",
            color: "#666",
            fontSize: "13px",
            fontWeight: "600",
          }}
        >
          รวมทั้งหมด:{" "}
          <strong style={{ color: "#1890ff", fontSize: "15px" }}>
            {total.toLocaleString()}
          </strong>{" "}
          สัญญา
        </p>
        <div
          style={{
            borderTop: "1px solid #e8e8e8",
            paddingTop: "12px",
            marginTop: "12px",
          }}
        >
          {payload
            .sort((a, b) => b.value - a.value)
            .map((entry, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "8px",
                  padding: "6px 8px",
                  backgroundColor: index % 2 === 0 ? "#f9f9f9" : "transparent",
                  borderRadius: "6px",
                }}
              >
                <span
                  style={{
                    color: entry.color,
                    fontSize: "13px",
                    fontWeight: "500",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      width: "10px",
                      height: "10px",
                      backgroundColor: entry.color,
                      borderRadius: "50%",
                      marginRight: "8px",
                    }}
                  ></span>
                  {entry.name}:
                </span>
                <strong
                  style={{
                    marginLeft: "12px",
                    fontSize: "14px",
                    color: "#333",
                  }}
                >
                  {entry.value.toLocaleString()}
                  <span
                    style={{
                      fontSize: "11px",
                      color: "#999",
                      marginLeft: "4px",
                    }}
                  >
                    ({((entry.value / total) * 100).toFixed(1)}%)
                  </span>
                </strong>
              </div>
            ))}
        </div>
      </div>
    );
  }
  return null;
};

// Custom Label สำหรับ Pie Chart
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  value,
  name,
}) => {
  const RADIAN = Math.PI / 180;
  const radius = outerRadius + 30;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  if (percent < 0.02) return null;

  return (
    <text
      x={x}
      y={y}
      fill="#333"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
      style={{ fontSize: "12px", fontWeight: "500" }}
    >
      {`${name}: ${value}`}
      <tspan x={x} dy="1.2em" style={{ fontSize: "11px", fill: "#666" }}>
        {`(${(percent * 100).toFixed(1)}%)`}
      </tspan>
    </text>
  );
};

// Custom Label สำหรับ Stacked Bar Chart - ปรับปรุงใหม่
const renderStackedBarLabel = (props) => {
  const { x, y, width, height, value, dataKey } = props;

  if (!value || value === 0) return null;

  // ลด threshold ให้แสดงข้อมูลแม้จะน้อย
  if (height < 10) return null;

  const fontSize = height >= 25 ? 12 : height >= 15 ? 10 : 8;

  // ถ้า bar สูงพอ (>30px) แสดงทั้งชื่อและจำนวน
  if (height >= 30) {
    const statusName = dataKey;

    return (
      <g>
        <text
          x={x + width / 2}
          y={y + height / 2 - 6}
          fill="white"
          textAnchor="middle"
          dominantBaseline="middle"
          style={{
            fontSize: `${fontSize}px`,
            fontWeight: "600",
            textShadow: "1px 1px 2px rgba(0,0,0,0.8)",
          }}
        >
          {statusName}
        </text>
        <text
          x={x + width / 2}
          y={y + height / 2 + 6}
          fill="white"
          textAnchor="middle"
          dominantBaseline="middle"
          style={{
            fontSize: `${fontSize + 1}px`,
            fontWeight: "bold",
            textShadow: "1px 1px 2px rgba(0,0,0,0.8)",
          }}
        >
          ({value})
        </text>
      </g>
    );
  }

  // ถ้า bar ขนาดกลาง (15-29px) แสดงเฉพาะจำนวน
  return (
    <text
      x={x + width / 2}
      y={y + height / 2}
      fill="white"
      textAnchor="middle"
      dominantBaseline="middle"
      style={{
        fontSize: `${fontSize}px`,
        fontWeight: "bold",
        textShadow: "1px 1px 3px rgba(0,0,0,0.9)",
      }}
    >
      {value}
    </text>
  );
};

// =====================================================
// Mobile Card Component
// =====================================================
const MobileRowCard = ({
  record,
  checked,
  onToggle,
  renderCancel,
  lawyersList,
}) => {
  const [, currencyFormatComma] = CurrencyFormat();

  const statusInfo = STATUS_OPTIONS.find(
    (item) => item.value === record?.MAIN_STATUS_ID
  );

  const latestLog = getLatestInvestigationLog(record?.investigation_log_list);

  return (
    <Card
      size="small"
      style={{
        borderRadius: 12,
        border: checked ? "2px solid #1890ff" : "1px solid #d9d9d9",
        boxShadow: checked ? "0 2px 8px rgba(24,144,255,0.2)" : "none",
      }}
      styles={{ body: { padding: 12 } }}
      onClick={onToggle}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 8,
          alignItems: "center",
        }}
      >
        <div style={{ fontWeight: 700, fontSize: 16 }}>{record?.CONTNO}</div>
        <Checkbox checked={checked} onChange={onToggle} />
      </div>

      <div style={{ marginTop: 8, color: "#666" }}>
        เลขตัวถัง: <b>{record?.STRNO || "-"}</b>
      </div>

      <div style={{ marginTop: 8, color: "#666" }}>
        จ่ายล่าสุด:{" "}
        <b>
          {record?.LPAYD
            ? dayjs(record.LPAYD).add(543, "year").format("D MMM YY")
            : "-"}
        </b>
      </div>

      <div style={{ marginTop: 6 }}>
        เกรด <b style={{ color: "crimson" }}>{record?.GRDCOD}</b> — ขาดติดต่อ{" "}
        {record?.LENGTHS} วัน
      </div>

      {statusInfo ? (
        <div style={{ marginTop: 8 }}>
          <Tag
            color={statusInfo.color || "default"}
            style={{ borderRadius: 8 }}
          >
            {statusInfo.icon} {statusInfo.label}
          </Tag>
          <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
            ผู้รับผิดชอบ: {getLawyerName(record?.USER_ID, lawyersList)}
          </div>
        </div>
      ) : (
        <div style={{ marginTop: 8 }}>
          <Tag color="default" style={{ borderRadius: 8 }}>
            ❌ ยังไม่ส่งทนาย
          </Tag>
        </div>
      )}

      {latestLog && (
        <div style={{ marginTop: 8 }}>
          <div style={{ fontSize: 12, color: "#666" }}>
            สถานะการสืบ:{" "}
            <Tag
              size="small"
              color={
                latestLog.investigation_status === 1
                  ? "green"
                  : latestLog.investigation_status === 0
                  ? "orange"
                  : "red"
              }
            >
              {OPTIONS_STATUS_INVESTIGATION.find(
                (s) => s.value === latestLog.investigation_status
              )?.label || "ไม่ระบุ"}
            </Tag>
          </div>
          {latestLog.investigation_date && (
            <div style={{ fontSize: 12, color: "#666" }}>
              วันที่สืบ:{" "}
              {dayjs(latestLog.investigation_date)
                .add(543, "year")
                .format("D MMM YY")}
            </div>
          )}
          {latestLog.department_of_lands && (
            <div style={{ fontSize: 12, color: "#666" }}>
              สถานที่: {latestLog.department_of_lands}
            </div>
          )}
          <div style={{ fontSize: 12, color: "#666" }}>
            ผู้สืบ: {getLawyerName(latestLog.investigator_id, lawyersList)}
          </div>
        </div>
      )}

      <div
        style={{
          marginTop: 12,
          padding: 8,
          backgroundColor: "#f5f5f5",
          borderRadius: 6,
        }}
      >
        <div style={{ fontSize: 12 }}>
          <div>
            ยอดจัด: <strong>{currencyFormatComma(record.BALANC)}</strong> บาท
          </div>
          <div>
            ชำระแล้ว: <strong>{currencyFormatComma(record.SMPAY)}</strong> บาท
          </div>
          <div>
            คงเหลือ:{" "}
            <span style={{ color: "#f5222d", fontWeight: "bold" }}>
              {(((record.BALANC - record.SMPAY) / record.BALANC) * 100).toFixed(
                0
              )}
              %
            </span>
          </div>
        </div>
      </div>
    </Card>
  );
};

// =====================================================
// Main Component
// =====================================================
const Main = () => {
  const [convertDateThai, convertDateThaiShort] = DateCustom();
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  const [lawyersList, setLoadingData, loadLawyerJobs] = LoadLawyers();
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;
  const [lawyersOption, setLawyersOption] = useState();
  const [dataAll, setDataAll] = useState();

  const [openFilter, setOpenFilter] = useState(false);
  const [openFilter2, setOpenFilter2] = useState(false);
  const [arrow, setArrow] = useState("Show");
  const [advanceSearch, setAdvanceSearch] = useState(false);
  const [loading, setLoading] = useState(false);

  const [dataType, setDataType] = useState(undefined);
  const [timeInput, setTimeInput] = useState(undefined);
  const [radioCheck, setRadioCheck] = useState(2);
  const [selectStatus, setSelectStatus] = useState(99);
  const [isSummaryMode, setIsSummaryMode] = useState(false);

  const [arrayTable, setArrayTable] = useState([]);
  const [arrData, setArrData] = useState([]);

  const [schemeData, setSchemeData] = useState({});
  const [stackedBarChartData, setStackedBarChartData] = useState([]);

  const [searchInput, setSearchInput] = useState("");
  const [selectRangeTime, setSelectRangeTime] = useState(null);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    setLoadingData(true);
  }, [setLoadingData]);

  useEffect(() => {
    if (lawyersList) {
      setOption();
    }
  }, [lawyersList]);

  const setOption = () => {
    let companySelect = null;

    if (userCompany === "1" || userCompany === "2") {
      companySelect = lawyersList.filter(
        (item) =>
          (item.COMPANY_ID === 1 || item.COMPANY_ID === 2) &&
          item.ROLE_ID === 3 &&
          item.ACTIVE_STATUS === 1
      );
    } else {
      companySelect = lawyersList.filter(
        (item) =>
          item.COMPANY_ID === 3 &&
          item.ROLE_ID === 3 &&
          item.ACTIVE_STATUS === 1
      );
    }
    const options = companySelect.map((item) => ({
      value: item.id,
      label: item.NNAME,
    }));

    setLawyersOption(options);
  };

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") return false;
    if (arrow === "Show") return true;
    return { pointAtCenter: true };
  }, [arrow]);

  const { pieData } = useChartData(arrayTable, isSummaryMode);

  const mergeDataWithLawyer = useCallback((mainData, lawyerData) => {
    console.log("Merging data", { mainData, lawyerData });

    const lawyerDataMap = new Map();

    if (Array.isArray(lawyerData)) {
      lawyerData.forEach((lawyerItem) => {
        const strno = lawyerItem.STRNO;
        if (strno) {
          if (!lawyerDataMap.has(strno)) {
            lawyerDataMap.set(strno, lawyerItem);
          }
        }
      });
    }

    const mergedResults = mainData.map((item) => {
      const lawyerInfo = lawyerDataMap.get(item.STRNO) || {};

      return {
        ...item,
        dataLawyer: lawyerInfo,
      };
    });

    return mergedResults;
  }, []);

  const loadDataLawyer = useCallback(async (contractList) => {
    console.log("loadDataLawyer", { contractList });

    if (!Array.isArray(contractList) || contractList.length === 0) {
      console.warn("contractList is not a valid array");
      return [];
    }

    const endpoint = GET_CEO_CHECK_MAIN_STATUS;

    try {
      const payload = {
        contractNo: contractList,
      };

      console.log("Payload:", payload);

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: endpoint,
        headers: {
          "Content-Type": "application/json",
          ...HEADERS_EXPORT,
        },
        data: payload,
      };

      const response = await axios.request(config);
      const { status, data } = response;

      if (status !== 200) {
        throw new Error(`HTTP ${status}`);
      }

      if (!data || (Array.isArray(data) && data.length === 0)) {
        console.warn("No lawyer data found");
        return [];
      }

      console.log("Lawyer data received:", data);
      return data;
    } catch (error) {
      const httpStatus = error?.response?.status;
      const serverMsg = error?.response?.data?.message;
      console.error(
        "loadDataLawyer error:",
        httpStatus,
        serverMsg || error.message
      );
      return [];
    }
  }, []);

  const loadDataForAllSchemes = useCallback(async () => {
    console.log("Loading data for all schemes");
    setLoading(true);

    const endpoint = POST_CEO_CHECK_CONTNO_MISS_CALL;

    try {
      const promises = ALL_SCHEME_TYPES.map(async (schemeType) => {
        const payload = {
          data_type: schemeType,
          status: radioCheck,
          value: timeInput,
          company: userCompany === "3" ? 2 : 1,
        };

        try {
          const { status, data } = await axios.post(endpoint, payload, {
            headers: HEADERS_EXPORT_BEN,
          });

          if (
            status === 200 &&
            data &&
            Array.isArray(data) &&
            data.length > 0
          ) {
            return {
              schemeType,
              data: data.map((item) => ({ ...item, schemeType })),
            };
          }

          return { schemeType, data: [] };
        } catch (error) {
          console.error(`Error loading ${schemeType}:`, error);
          return { schemeType, data: [] };
        }
      });

      const results = await Promise.all(promises);
      console.log("All schemes data:", results);

      let allData = [];
      const schemeDataObj = {};

      results.forEach(({ schemeType, data }) => {
        schemeDataObj[schemeType] = data;
        allData = [...allData, ...data];
      });

      if (allData.length === 0) {
        message.warning("ไม่มีข้อมูล");
        setArrayTable([]);
        setArrData([]);
        setSchemeData({});
        setStackedBarChartData([]);
        return;
      }

      const formattedData = allData.map((item, index) => ({
        ...item,
        key: index + 1,
      }));

      const contractNoList = formattedData.map((item) => item.CONTNO);
      const lawyerData = await loadDataLawyer(contractNoList);
      const mergedData = mergeDataWithLawyer(formattedData, lawyerData);

      // สร้างข้อมูลสำหรับ Stacked Bar Chart
      const stackedData = [];

      results.forEach(({ schemeType, data }) => {
        if (data.length === 0) return;

        const schemeLabel =
          SCHEME_TYPE_OPTIONS.find((opt) => opt.value === schemeType)?.label ||
          schemeType;

        const statusCounts = {};

        data.forEach((item) => {
          const lawyerInfo = lawyerData.find((l) => l.STRNO === item.STRNO);
          const statusId = lawyerInfo?.MAIN_STATUS_ID;

          if (!statusId && statusId !== 0) {
            statusCounts["ยังไม่ส่งทนาย"] =
              (statusCounts["ยังไม่ส่งทนาย"] || 0) + 1;
          } else {
            const statusInfo = STATUS_OPTIONS.find((s) => s.value === statusId);
            if (statusInfo && statusId !== 99) {
              const statusLabel = statusInfo.label;
              statusCounts[statusLabel] = (statusCounts[statusLabel] || 0) + 1;
            }
          }
        });

        const barData = {
          name: schemeLabel,
          schemeType: schemeType,
        };

        Object.keys(statusCounts).forEach((statusLabel) => {
          barData[statusLabel] = statusCounts[statusLabel];
        });

        stackedData.push(barData);
      });

      console.log("Stacked bar chart data:", stackedData);

      setSchemeData(schemeDataObj);
      setStackedBarChartData(stackedData);
      setArrData(mergedData);
      setArrayTable(mergedData);
      setAdvanceSearch(true);
      message.success(
        `พบข้อมูล ${mergedData.length} รายการ จาก ${results.length} ประเภทสัญญา`
      );
    } catch (error) {
      console.error("loadDataForAllSchemes error:", error);
      message.error("เกิดข้อผิดพลาดในการโหลดข้อมูล");
      setArrayTable([]);
      setArrData([]);
      setSchemeData({});
      setStackedBarChartData([]);
    } finally {
      setLoading(false);
    }
  }, [timeInput, radioCheck, loadDataLawyer, mergeDataWithLawyer]);

  const loadDataDB2 = useCallback(async () => {
    console.log("loadData", { dataType, timeInput, radioCheck });

    if (!dataType) {
      message.error("กรุณาเลือกประเภทสัญญา");
      return;
    }
    if (!timeInput) {
      message.error("กรุณากรอกระยะเวลา");
      return;
    }

    if (dataType === "all") {
      await loadDataForAllSchemes();
      return;
    }

    setLoading(true);

    const isSummary = dataType === "1" || dataType === "2";
    const endpoint = isSummary
      ? POST_CEO_CHECK_SUMMARY_MISS_CALL
      : POST_CEO_CHECK_CONTNO_MISS_CALL;

    const payload = {
      data_type:
        dataType === "1" ? "vsfhp" : dataType === "2" ? "tsfhp" : dataType,
      status: radioCheck,
      value: timeInput,
      company: userCompany === "3" ? 2 : 1,
    };

    try {
      const { status, data } = await axios.post(endpoint, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (status !== 200) {
        throw new Error(`HTTP ${status}`);
      }

      if (
        !data ||
        (Array.isArray(data) && data.length === 0) ||
        status === 201
      ) {
        message.warning("ไม่มีข้อมูล");
        setArrayTable([]);
        setArrData([]);
        setDataAll(null);
        setSchemeData({});
        setStackedBarChartData([]);
        return;
      }

      if (isSummary) {
        console.log("Summary Mode:", data);

        if (!data.ALLCONTNO || !Array.isArray(data.ALLCONTNO)) {
          message.warning("ไม่มีข้อมูล ALLCONTNO");
          setArrayTable([]);
          setArrData([]);
          setDataAll(null);
          setSchemeData({});
          setStackedBarChartData([]);
          return;
        }

        setDataAll(data);

        const lawyerData = await loadDataLawyer(data.ALLCONTNO);

        console.log("Lawyer Data:", lawyerData);

        const formattedData = lawyerData.map((item, index) => ({
          ...item,
          key: index + 1,
        }));

        setArrData(formattedData);
        setArrayTable(formattedData);
        setAdvanceSearch(true);
        setSchemeData({});
        setStackedBarChartData([]);
        message.success(`พบข้อมูล ${formattedData.length} รายการ`);
      } else {
        console.log("Normal Mode:", data);
        setDataAll(data);

        const formattedData = Array.isArray(data)
          ? data.map((item, index) => ({
              ...item,
              key: index + 1,
            }))
          : [];

        const contractNoList = formattedData.map((item) => item.CONTNO);
        const lawyerData = await loadDataLawyer(contractNoList);

        const mergedData = mergeDataWithLawyer(formattedData, lawyerData);

        console.log("Merged data:", mergedData);

        setArrData(mergedData);
        setArrayTable(mergedData);
        setAdvanceSearch(true);
        setSchemeData({});
        setStackedBarChartData([]);
        message.success(`พบข้อมูล ${mergedData.length} รายการ`);
      }
    } catch (error) {
      const httpStatus = error?.response?.status;
      const serverMsg = error?.response?.data?.message;
      console.error("loadData error:", httpStatus, serverMsg || error.message);

      message.error(
        serverMsg || `ไม่สามารถดึงข้อมูลได้ (${httpStatus ?? "-"})`
      );
      setArrayTable([]);
      setArrData([]);
      setDataAll(null);
      setSchemeData({});
      setStackedBarChartData([]);
    } finally {
      setLoading(false);
    }
  }, [
    dataType,
    timeInput,
    radioCheck,
    loadDataLawyer,
    mergeDataWithLawyer,
    loadDataForAllSchemes,
  ]);

  const toggle = useCallback(() => {
    setAdvanceSearch((v) => !v);
  }, []);

  const onQueryData = useCallback(() => {
    setIsSummaryMode(dataType === "1" || dataType === "2" ? true : false);
    if (dataType && timeInput !== undefined) {
      loadDataDB2();
    } else {
      if (!dataType) message.warning("กรุณาเลือกประเภทสัญญา");
      if (timeInput === undefined) message.warning("กรุณากรอกระยะเวลา");
    }
  }, [dataType, timeInput, loadDataDB2]);

  const handleChangeDataType = useCallback((value) => {
    setDataType(value);
  }, []);

  const handleChangeTimeInput = useCallback((value) => {
    setTimeInput(value);
  }, []);

  const handleChangeRadio = useCallback((e) => {
    const value = e.target.value;
    setRadioCheck(value);
    console.log("Radio changed:", value === 1 ? "ตามวัน" : "ตามงวด");
  }, []);

  const handleChangeStatus = useCallback((value) => {
    setSelectStatus(value);
    console.log("Status changed:", value);
  }, []);

  const clearFilters = useCallback(() => {
    setDataType(undefined);
    setTimeInput(undefined);
    setRadioCheck(2);
    setSelectStatus(99);
    setSearchInput("");
    setSelectRangeTime(null);
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setArrayTable([]);
    setArrData([]);
    setAdvanceSearch(false);
    setDataAll(null);
    setSchemeData({});
    setStackedBarChartData([]);
    message.info("ล้างตัวกรองเรียบร้อย");
  }, []);

  const clearAdvancedFilters = useCallback(() => {
    setSearchInput("");
    setSelectRangeTime(null);
    setSelectStatus(99);
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setArrayTable(arrData);
  }, [arrData]);

  const onChangeInputSearch = useCallback((value) => {
    setSearchInput(value);
  }, []);

  const handlefilterData = useCallback(() => {
    let filtered = [...arrData];

    if (searchInput) {
      const searchTerm = searchInput.toUpperCase();
      filtered = filtered.filter(
        (item) =>
          item.CONTNO?.toUpperCase().includes(searchTerm) ||
          item.STRNO?.toUpperCase().includes(searchTerm)
      );
    }

    if (selectStatus !== 99) {
      if (selectStatus === null) {
        filtered = filtered.filter((item) => {
          const statusId = isSummaryMode
            ? item.MAIN_STATUS_ID
            : item.dataLawyer?.MAIN_STATUS_ID;
          return !statusId && statusId !== 0;
        });
      } else {
        filtered = filtered.filter((item) => {
          const statusId = isSummaryMode
            ? item.MAIN_STATUS_ID
            : item.dataLawyer?.MAIN_STATUS_ID;
          return statusId === selectStatus;
        });
      }
    }

    setArrayTable(filtered);
    message.success(`กรองข้อมูลแล้ว พบ ${filtered.length} รายการ`);
  }, [arrData, searchInput, selectStatus, isSummaryMode]);

  const renderCancelContract = useCallback((record) => {
    if (!record.statusActiveCancelContno) {
      return <Tag color="default">ยังไม่ออกบอกเลิก</Tag>;
    }

    return (
      <Tag color="orange">
        ออกบอกเลิกแล้ว
        {record.dateCancelContno && (
          <>
            <br />
            {dayjs(record.dateCancelContno).add(543, "year").format("D MMM YY")}
          </>
        )}
      </Tag>
    );
  }, []);

  const renderStatusFilter = useCallback(() => {
    if (isMobile) {
      return (
        <Select
          placeholder="เลือกสถานะ"
          value={selectStatus}
          onChange={handleChangeStatus}
          size="large"
          style={{ width: "100%" }}
        >
          {STATUS_OPTIONS_SELECT.map((opt) => (
            <Option key={opt.value} value={opt.value}>
              {opt.icon} {opt.label}
            </Option>
          ))}
        </Select>
      );
    }

    return (
      <Select
        placeholder="เลือกสถานะ"
        value={selectStatus}
        onChange={handleChangeStatus}
        size="large"
        style={{ width: 250, borderRadius: 8, marginBottom: 5 }}
      >
        {STATUS_OPTIONS_SELECT.map((opt) => (
          <Option key={opt.value} value={opt.value}>
            {opt.icon} {opt.label}
          </Option>
        ))}
      </Select>
    );
  }, [isMobile, selectStatus, handleChangeStatus]);

  const rowSelection = useMemo(
    () => ({
      selectedRowKeys,
      onChange: (keys, rows) => {
        setSelectedRowKeys(keys);
        setSelectedRows(rows);
      },
    }),
    [selectedRowKeys]
  );

  const handleExportExcel = async () => {
    setLoading(true);

    let useData;
    if (arrData.length > 0) {
      useData = arrData;
    }

    try {
      await ExportSimpleContractList(useData);
      message.success("โหลด Excel สำเร็จ");
    } catch (e) {
      console.error(e);
      message.error(`พิมพ์ไม่สำเร็จ: ${e?.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        title: "ลำดับ",
        align: "center",
        dataIndex: "key",
        width: 80,
        render: (text, record) => (
          <span style={{ fontWeight: "bold" }}>{record.key}</span>
        ),
      },
      {
        title: "เลขสัญญา",
        align: "center",
        width: 150,
        render: (record) => (
          <>
            <div style={{ fontSize: 14, fontWeight: "bold" }}>
              {record.CONTNO}
              <br />
            </div>
            {record.schemeType && (
              <Tag color="blue" size="small" style={{ marginTop: 4 }}>
                {SCHEME_TYPE_OPTIONS.find(
                  (opt) => opt.value === record.schemeType
                )?.label || record.schemeType}
              </Tag>
            )}
          </>
        ),
      },
      {
        title: "สัญญาเดิม",
        align: "center",
        width: 150,
        render: (text, record) => (
          <div>
            <div style={{ fontSize: 12, color: "red" }}>{record.ISSUNO}</div>
          </div>
        ),
      },
      {
        title: "จ่ายล่าสุด",
        align: "center",
        width: 150,
        render: (text, record) => (
          <div>
            <div style={{ fontSize: 12, color: "#888" }}>
              {record?.SMPAY ? convertDateThaiShort(record.LPAYD) : "-"}
            </div>
          </div>
        ),
      },
      {
        title: "เกรด",
        align: "center",
        width: 150,
        render: (text, record) => (
          <div>
            <div style={{ color: "red" }}>เกรด {record.GRDCOD}</div>
            <div style={{ fontSize: 12, color: "#888" }}>
              ขาดการติดต่อ {record.LENGTHS} วัน / {record.EXP_PRD} งวด
            </div>
            <div style={{ fontSize: 12, color: "#888" }}>
              ยอดรับฝาก {currencyFormatOne(record?.HD_TOTAMT)} บาท
            </div>
          </div>
        ),
      },
      {
        title: "สถานะทนาย",
        align: "center",
        width: 200,
        render: (text, record) => {
          const statusId = isSummaryMode
            ? record.MAIN_STATUS_ID
            : record.dataLawyer?.MAIN_STATUS_ID;

          const userId = isSummaryMode
            ? record.USER_ID
            : record.dataLawyer?.USER_ID;

          const investigationLogs = isSummaryMode
            ? record.investigation_log_list
            : record.dataLawyer?.investigation_log_list;

          const statusInfo = STATUS_OPTIONS.find(
            (item) => item.value === statusId
          );

          const latestLog = getLatestInvestigationLog(investigationLogs);

          if (!statusInfo) {
            return <Tag color="default">ยังไม่ส่งทนาย</Tag>;
          }

          const tooltipContent = latestLog ? (
            <div
              style={{
                textAlign: "center",
              }}
            >
              <div>
                วันที่สืบ:{" "}
                {dayjs(latestLog.investigation_date)
                  .add(543, "year")
                  .format("D MMMM YYYY")}
              </div>
              {latestLog.department_of_lands && (
                <div>สถานที่: {latestLog.department_of_lands}</div>
              )}
              {latestLog.investigation_status !== null && (
                <>
                  <div>
                    สถานะการสืบ:{" "}
                    {OPTIONS_STATUS_INVESTIGATION.find(
                      (s) => s.value === latestLog.investigation_status
                    )?.label || "-"}
                  </div>
                  <br />
                  ผู้สืบ:{" "}
                  {getLawyerName(latestLog.investigator_id, lawyersList)}
                </>
              )}
            </div>
          ) : null;

          return (
            <Tooltip title={tooltipContent} placement="topLeft">
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <Tag
                  color={statusInfo.color || "default"}
                  style={{
                    padding: "4px 10px",
                    cursor: latestLog ? "pointer" : "default",
                  }}
                >
                  {statusInfo.icon} {statusInfo.label}
                  <br />
                  ผู้รับผิดชอบ: {getLawyerName(userId, lawyersList)}
                </Tag>
              </div>
            </Tooltip>
          );
        },
      },
      {
        title: "สถานะสืบทรัพย์",
        align: "center",
        width: 200,
        render: (text, record) => {
          const investigationLogs = isSummaryMode
            ? record.investigation_log_list
            : record.dataLawyer?.investigation_log_list;

          const latestLog = getLatestInvestigationLog(investigationLogs);

          if (!latestLog) {
            return <Tag color="default">ไม่มีข้อมูลการสืบ</Tag>;
          }

          return (
            <div>
              {latestLog.investigation_status !== null && (
                <Tag
                  size="small"
                  color={
                    latestLog.investigation_status === 1
                      ? "green"
                      : latestLog.investigation_status === 0
                      ? "orange"
                      : "red"
                  }
                  style={{ marginTop: 4 }}
                >
                  {OPTIONS_STATUS_INVESTIGATION.find(
                    (s) => s.value === latestLog.investigation_status
                  )?.label || "ไม่ระบุ"}
                </Tag>
              )}
              <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
                {latestLog.investigation_date && (
                  <div>
                    วันที่สืบ:{" "}
                    {dayjs(latestLog.investigation_date)
                      .add(543, "year")
                      .format("D MMM YY")}
                  </div>
                )}
                {latestLog.department_of_lands && (
                  <div>สถานที่: {latestLog.department_of_lands}</div>
                )}
                ผู้สืบ: {getLawyerName(latestLog.investigator_id, lawyersList)}
              </div>
            </div>
          );
        },
      },
      {
        title: "รายละเอียด",
        dataIndex: "CONTNO",
        key: "CONTNO",
        align: "center",
        width: 180,
        render: (text, record) => (
          <div style={{ lineHeight: 1.6 }}>
            <div>
              ยอดจัด <b>{currencyFormatComma(record.BALANC)}</b> บาท
            </div>
            <div>
              ชำระรวม <b>{currencyFormatComma(record.SMPAY)}</b> บาท
            </div>
            <div>
              คงเหลือ{" "}
              <span style={{ color: "#f5222d", fontWeight: "bold" }}>
                {(
                  ((record.BALANC - record.SMPAY) / record.BALANC) *
                  100
                ).toFixed(0)}
                %
              </span>
            </div>
          </div>
        ),
      },
    ],
    [convertDateThaiShort, currencyFormatComma, lawyersList, isSummaryMode]
  );

  // เรียงลำดับสถานะตาม STATUS_ORDER
  const uniqueStatuses = useMemo(() => {
    if (!stackedBarChartData || stackedBarChartData.length === 0) return [];

    const statusSet = new Set();
    stackedBarChartData.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (key !== "name" && key !== "schemeType") {
          statusSet.add(key);
        }
      });
    });

    const allStatuses = Array.from(statusSet);

    // เรียงตาม STATUS_ORDER
    return allStatuses.sort((a, b) => {
      const indexA = STATUS_ORDER.indexOf(a);
      const indexB = STATUS_ORDER.indexOf(b);

      // ถ้าไม่อยู่ใน STATUS_ORDER ให้ไปท้ายสุด
      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;

      return indexA - indexB;
    });
  }, [stackedBarChartData]);

  return (
    <div>
      <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
        {/* แถบค้นหา/ฟิลเตอร์หลัก */}
        <Card style={{ marginBottom: 8 }}>
          <Row gutter={[8, 8]}>
            <Col span={24} style={{ textAlign: "start" }}>
              {isMobile ? (
                <>
                  <Space wrap size={5}>
                    <Button
                      icon={<FilterOutlined />}
                      style={{ borderRadius: 8 }}
                      onClick={() => setOpenFilter(true)}
                    >
                      ตัวกรอง
                    </Button>
                    <Button
                      type="primary"
                      icon={<SearchOutlined />}
                      size="middle"
                      style={{ borderRadius: 8 }}
                      onClick={onQueryData}
                      loading={loading}
                    >
                      ค้นหา
                    </Button>
                    <Button
                      icon={<ReloadOutlined />}
                      danger
                      onClick={clearFilters}
                      size="middle"
                      style={{ borderRadius: 8 }}
                    >
                      ล้าง
                    </Button>
                  </Space>

                  <Drawer
                    title="ตัวกรอง"
                    open={openFilter}
                    onClose={() => setOpenFilter(false)}
                    width="100%"
                    style={{ paddingBottom: 24 }}
                  >
                    <Space
                      direction="vertical"
                      size={10}
                      style={{ width: "100%" }}
                    >
                      <Select
                        placeholder="เลือกประเภทสัญญา"
                        value={dataType}
                        onChange={handleChangeDataType}
                        size="large"
                        style={{ width: "100%" }}
                      >
                        {SCHEME_TYPE_OPTIONS.map((opt) => (
                          <Option key={opt.value} value={opt.value}>
                            {opt.label}
                          </Option>
                        ))}
                      </Select>
                      <Radio.Group
                        value={radioCheck}
                        onChange={handleChangeRadio}
                        style={{ width: "100%" }}
                      >
                        <Space direction="vertical" size={10}>
                          <Radio value={1}>ตามวัน</Radio>
                          <Radio value={2}>ตามงวด</Radio>
                        </Space>
                      </Radio.Group>
                      <InputNumber
                        placeholder="จำนวนวันขาดการติดต่อ"
                        value={timeInput}
                        onChange={handleChangeTimeInput}
                        size="large"
                        style={{ width: "100%" }}
                        min={1}
                        suffix={radioCheck === 1 ? "วัน" : "งวด"}
                      />
                    </Space>

                    <Button
                      type="primary"
                      block
                      size="large"
                      style={{ marginTop: 16, borderRadius: 8 }}
                      onClick={() => {
                        setOpenFilter(false);
                        onQueryData();
                      }}
                      loading={loading}
                    >
                      ใช้ตัวกรอง
                    </Button>
                  </Drawer>
                </>
              ) : (
                <>
                  <Tooltip
                    title={advanceSearch ? "ซ่อนตัวกรอง" : "แสดงตัวกรอง"}
                    arrow={mergedArrow}
                  >
                    {!advanceSearch ? (
                      <DownSquareOutlined
                        style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                        onClick={toggle}
                      />
                    ) : (
                      <UpSquareOutlined
                        style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                        onClick={toggle}
                      />
                    )}
                  </Tooltip>

                  <Space direction="horizontal" size={10} wrap>
                    <Select
                      placeholder="เลือกประเภทสัญญา"
                      value={dataType}
                      onChange={handleChangeDataType}
                      size="large"
                      style={{ width: 160 }}
                    >
                      {SCHEME_TYPE_OPTIONS.map((opt) => (
                        <Option key={opt.value} value={opt.value}>
                          {opt.label}
                        </Option>
                      ))}
                    </Select>

                    <Radio.Group
                      value={radioCheck}
                      onChange={handleChangeRadio}
                      size="large"
                    >
                      <Radio.Button value={1}>ตามวัน</Radio.Button>
                      <Radio.Button value={2}>ตามงวด</Radio.Button>
                    </Radio.Group>
                    <InputNumber
                      placeholder="จำนวนวันขาดการติดต่อ"
                      value={timeInput}
                      onChange={handleChangeTimeInput}
                      formatter={(value) =>
                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                      size="large"
                      style={{ width: "auto" }}
                      min={radioCheck === 1 ? 120 : 3}
                      suffix={radioCheck === 1 ? "วัน" : "งวด"}
                    />

                    <Button
                      type="primary"
                      icon={<SearchOutlined />}
                      size="large"
                      style={{
                        borderRadius: 8,
                        boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                        fontWeight: "bold",
                        background: "linear-gradient(135deg, #667eea, blue)",
                        border: "none",
                      }}
                      onClick={onQueryData}
                      loading={loading}
                    >
                      ค้นหา
                    </Button>

                    <Button
                      icon={<ReloadOutlined />}
                      onClick={clearFilters}
                      color="red"
                      variant="outlined"
                      size="large"
                    >
                      ล้าง
                    </Button>
                  </Space>
                </>
              )}
            </Col>
          </Row>
        </Card>

        {/* Charts Section */}
        {arrayTable.length > 0 && (
          <Card style={{ marginBottom: 8 }}>
            <Row gutter={[24, 24]}>
              {/* แสดง Stacked Bar Chart เมื่อเลือก "ทุกสัญญา" */}
              {dataType === "all" && stackedBarChartData.length > 0 ? (
                <Col xs={24}>
                  <div style={{ textAlign: "center", marginBottom: 16 }}>
                    <h3 style={{ margin: 0, fontSize: isMobile ? 16 : 18 }}>
                      📊 จำนวนสัญญาแยกตามประเภทและสถานะ
                    </h3>
                    <p
                      style={{ margin: "8px 0 0", fontSize: 12, color: "#666" }}
                    >
                      คลิกที่แท่งกราฟเพื่อดูรายละเอียด
                    </p>
                  </div>
                  <ResponsiveContainer
                    width="100%"
                    height={isMobile ? 450 : 550}
                  >
                    <BarChart
                      data={stackedBarChartData}
                      margin={{ top: 20, right: 30, left: 20, bottom: 100 }}
                      barSize={60}
                    >
                      <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                      <XAxis
                        dataKey="name"
                        angle={-45}
                        textAnchor="end"
                        height={100}
                        style={{ fontSize: isMobile ? 10 : 12 }}
                        stroke="#666"
                      />
                      <YAxis stroke="#666" />
                      <RechartsTooltip content={<CustomStackedBarTooltip />} />
                      <Legend
                        wrapperStyle={{
                          paddingTop: 20,
                          fontSize: isMobile ? 10 : 12,
                        }}
                        iconSize={12}
                      />
                      {uniqueStatuses.map((statusLabel, index) => {
                        const statusInfo = STATUS_OPTIONS.find(
                          (s) => s.label === statusLabel
                        );
                        const color = statusInfo
                          ? CHART_COLORS[statusInfo.color] || "#8884d8"
                          : statusLabel === "ยังไม่ส่งทนาย"
                          ? CHART_COLORS.gray
                          : "#8884d8";

                        return (
                          <Bar
                            key={statusLabel}
                            dataKey={statusLabel}
                            stackId="a"
                            fill={color}
                            radius={
                              index === uniqueStatuses.length - 1
                                ? [8, 8, 0, 0]
                                : 0
                            }
                            stroke="#fff"
                            strokeWidth={1}
                          >
                            <LabelList
                              dataKey={statusLabel}
                              position="center"
                              content={renderStackedBarLabel}
                            />
                          </Bar>
                        );
                      })}
                    </BarChart>
                  </ResponsiveContainer>
                </Col>
              ) : (
                /* แสดง Pie Chart พร้อม Label สำหรับโหมดอื่นๆ */
                <Col xs={24}>
                  <div style={{ textAlign: "center", marginBottom: 16 }}>
                    <h3 style={{ margin: 0, fontSize: isMobile ? 16 : 18 }}>
                      📊 สัดส่วนสัญญาตามสถานะ
                    </h3>
                  </div>
                  <ResponsiveContainer
                    width="100%"
                    height={isMobile ? 550 : 650}
                  >
                    <PieChart>
                      <Pie
                        data={pieData.map((item) => ({
                          ...item,
                          percent: item.value / arrayTable.length,
                        }))}
                        cx="50%"
                        cy="50%"
                        labelLine={{
                          stroke: "#999",
                          strokeWidth: 1,
                        }}
                        label={renderCustomizedLabel}
                        outerRadius={isMobile ? 90 : 120}
                        fill="#8884d8"
                        dataKey="value"
                        paddingAngle={2}
                      >
                        {pieData.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={CHART_COLORS[entry.color] || "#d9d9d9"}
                          />
                        ))}
                      </Pie>
                      <RechartsTooltip content={<CustomTooltip />} />
                      <Legend
                        verticalAlign="bottom"
                        height={isMobile ? 100 : 80}
                        layout="horizontal"
                        align="center"
                        formatter={(value, entry) => {
                          const item = pieData.find((d) => d.name === value);
                          return (
                            <span style={{ fontSize: isMobile ? 11 : 13 }}>
                              {entry.payload.icon} {value}
                            </span>
                          );
                        }}
                        wrapperStyle={{
                          paddingTop: 20,
                          fontSize: isMobile ? 11 : 13,
                        }}
                        iconSize={16}
                      />
                    </PieChart>
                  </ResponsiveContainer>
                </Col>
              )}
            </Row>

            {/* สรุปข้อมูลรวม */}
            <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
              {isSummaryMode ? (
                <>
                  <Col xs={12} sm={6}>
                    <Card
                      size="small"
                      style={{ textAlign: "center", borderRadius: 8 }}
                    >
                      <div style={{ fontSize: 12, color: "#666" }}>
                        จำนวนสัญญาทั้งหมด
                      </div>
                      <div
                        style={{
                          fontSize: 24,
                          fontWeight: "bold",
                          color: "#1890ff",
                        }}
                      >
                        {(dataAll?.ALLCONTNO?.length || 0).toLocaleString()}
                      </div>
                    </Card>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Card
                      size="small"
                      style={{ textAlign: "center", borderRadius: 8 }}
                    >
                      <div style={{ fontSize: 12, color: "#666" }}>
                        ยอดจัดรวม
                      </div>
                      <div
                        style={{
                          fontSize: isMobile ? 16 : 20,
                          fontWeight: "bold",
                          color: "#52c41a",
                        }}
                      >
                        {currencyFormatOne(dataAll?.TOTAL_BALANC || 0)}
                      </div>
                    </Card>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Card
                      size="small"
                      style={{ textAlign: "center", borderRadius: 8 }}
                    >
                      <div style={{ fontSize: 12, color: "#666" }}>
                        ลูกหนี้คงเหลือ
                      </div>
                      <div
                        style={{
                          fontSize: isMobile ? 16 : 20,
                          fontWeight: "bold",
                          color: "#f5222d",
                        }}
                      >
                        {currencyFormatOne(
                          (dataAll?.TOTAL_BALANC || 0) -
                            (dataAll?.TOTAL_SMPAY || 0)
                        )}
                        <br />
                        <span style={{ fontSize: 14, color: "#666" }}>
                          {dataAll?.TOTAL_BALANC > 0
                            ? (
                                (((dataAll?.TOTAL_BALANC || 0) -
                                  (dataAll?.TOTAL_SMPAY || 0)) /
                                  dataAll?.TOTAL_BALANC) *
                                100
                              ).toFixed(2)
                            : 0}
                          %
                        </span>
                      </div>
                    </Card>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Card
                      size="small"
                      style={{ textAlign: "center", borderRadius: 8 }}
                    >
                      <div style={{ fontSize: 12, color: "#666" }}>
                        ลูกหนี้ชำระ
                      </div>
                      <div
                        style={{
                          fontSize: isMobile ? 16 : 20,
                          fontWeight: "bold",
                          color: "#722ed1",
                        }}
                      >
                        {currencyFormatOne(dataAll?.TOTAL_SMPAY || 0)}
                        <br />
                        <span style={{ fontSize: 14, color: "#666" }}>
                          {dataAll?.TOTAL_BALANC > 0
                            ? (
                                ((dataAll?.TOTAL_SMPAY || 0) /
                                  dataAll?.TOTAL_BALANC) *
                                100
                              ).toFixed(2)
                            : 0}
                          %
                        </span>
                      </div>
                    </Card>
                  </Col>
                </>
              ) : (
                <>
                  <Col xs={12} sm={6}>
                    <Card
                      size="small"
                      style={{ textAlign: "center", borderRadius: 8 }}
                    >
                      <div style={{ fontSize: 12, color: "#666" }}>
                        จำนวนสัญญาทั้งหมด
                      </div>
                      <div
                        style={{
                          fontSize: 24,
                          fontWeight: "bold",
                          color: "#1890ff",
                        }}
                      >
                        {arrayTable.length.toLocaleString()}
                      </div>
                    </Card>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Card
                      size="small"
                      style={{ textAlign: "center", borderRadius: 8 }}
                    >
                      <div style={{ fontSize: 12, color: "#666" }}>
                        ยอดจัดรวม{" "}
                        {dataType === "rpsl" ? "(เฉพาะเงินต้น)" : null}
                      </div>
                      <div
                        style={{
                          fontSize: isMobile ? 16 : 20,
                          fontWeight: "bold",
                          color: "#52c41a",
                        }}
                      >
                        {currencyFormatOne(
                          arrayTable.reduce(
                            (sum, item) => sum + (item.BALANC || 0),
                            0
                          )
                        )}
                      </div>
                    </Card>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Card
                      size="small"
                      style={{ textAlign: "center", borderRadius: 8 }}
                    >
                      <div style={{ fontSize: 12, color: "#666" }}>
                        ลูกหนี้คงเหลือ{" "}
                        {dataType === "rpsl" ? "(เฉพาะเงินต้น)" : null}
                      </div>
                      <div
                        style={{
                          fontSize: isMobile ? 16 : 20,
                          fontWeight: "bold",
                          color: "#f5222d",
                        }}
                      >
                        {currencyFormatOne(
                          arrayTable.reduce(
                            (sum, item) =>
                              sum + ((item.BALANC || 0) - (item.SMPAY || 0)),
                            0
                          )
                        )}
                      </div>
                    </Card>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Card
                      size="small"
                      style={{ textAlign: "center", borderRadius: 8 }}
                    >
                      <div style={{ fontSize: 12, color: "#666" }}>
                        ลูกหนี้ชำระ
                      </div>
                      <div
                        style={{
                          fontSize: isMobile ? 16 : 20,
                          fontWeight: "bold",
                          color: "#722ed1",
                        }}
                      >
                        {currencyFormatOne(
                          arrayTable.reduce(
                            (sum, item) => sum + (item.SMPAY || 0),
                            0
                          )
                        )}
                      </div>
                    </Card>
                  </Col>
                </>
              )}
            </Row>
          </Card>
        )}

        {/* ฟิลเตอร์เสริม + ตาราง/การ์ด */}
        {!isSummaryMode && (
          <Card>
            <Row gutter={[8, 8]}>
              <Col span={24} style={{ textAlign: "start" }}>
                {isMobile ? (
                  <>
                    <Space wrap size={10}>
                      <Button
                        icon={<FilterOutlined />}
                        style={{ borderRadius: 8 }}
                        onClick={() => setOpenFilter2(true)}
                      >
                        ตัวกรองเพิ่มเติม
                      </Button>
                    </Space>

                    <Drawer
                      title="ตัวกรองเพิ่มเติม"
                      open={openFilter2}
                      onClose={() => setOpenFilter2(false)}
                      width="100%"
                    >
                      <Space
                        direction="vertical"
                        size={10}
                        style={{ width: "100%" }}
                      >
                        <Input
                          placeholder="ค้นหาเลขสัญญา/เลขตัวถัง"
                          value={searchInput}
                          onChange={(e) => onChangeInputSearch(e.target.value)}
                          size="large"
                          style={{ width: "100%", borderRadius: 8 }}
                          prefix={<SearchOutlined />}
                        />

                        {renderStatusFilter()}

                        <Button
                          type="primary"
                          icon={<FilterOutlined />}
                          size="large"
                          block
                          style={{ borderRadius: 8 }}
                          onClick={() => {
                            setOpenFilter2(false);
                            handlefilterData();
                          }}
                        >
                          กรองข้อมูล
                        </Button>

                        <Button
                          icon={<ReloadOutlined />}
                          onClick={clearAdvancedFilters}
                          size="large"
                          block
                          color="red"
                          variant="outlined"
                          style={{ borderRadius: 8 }}
                        >
                          ล้าง
                        </Button>
                      </Space>
                    </Drawer>
                  </>
                ) : (
                  <>
                    {advanceSearch && (
                      <Space size={10} wrap>
                        <Input
                          placeholder="ค้นหาเลขสัญญา/เลขตัวถัง"
                          value={searchInput}
                          onChange={(e) => onChangeInputSearch(e.target.value)}
                          style={{
                            width: 250,
                            borderRadius: 8,
                            marginBottom: 5,
                          }}
                          size="small"
                          prefix={<SearchOutlined />}
                        />

                        {renderStatusFilter()}

                        <Button
                          type="default"
                          icon={<FilterOutlined />}
                          size="large"
                          style={{
                            borderRadius: 8,
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            fontWeight: "bold",
                            backgroundColor: "#fff7d6",
                            color: "#333",
                            border: "1px solid #ffe58f",
                            marginBottom: 5,
                          }}
                          onClick={handlefilterData}
                        >
                          กรองข้อมูล
                        </Button>

                        <Button
                          icon={<ReloadOutlined />}
                          onClick={clearAdvancedFilters}
                          color="red"
                          variant="outlined"
                          size="large"
                          style={{ marginBottom: 5 }}
                        >
                          ล้าง
                        </Button>
                        <Button
                          icon={<FileExcelOutlined />}
                          onClick={handleExportExcel}
                          color="green"
                          variant="outlined"
                          size="large"
                          style={{ marginBottom: 5 }}
                        >
                          Export excel
                        </Button>
                      </Space>
                    )}
                  </>
                )}
              </Col>

              <Col span={24}>
                {isMobile ? (
                  <Space
                    direction="vertical"
                    size={8}
                    style={{ width: "100%" }}
                  >
                    {arrayTable?.length > 0 ? (
                      <>
                        {arrayTable.map((r) => (
                          <MobileRowCard
                            key={r.key}
                            record={r}
                            checked={selectedRowKeys.includes(r.key)}
                            onToggle={() => {
                              const checked = selectedRowKeys.includes(r.key);
                              const nextKeys = checked
                                ? selectedRowKeys.filter((k) => k !== r.key)
                                : [...selectedRowKeys, r.key];
                              const nextRows = checked
                                ? selectedRows.filter((x) => x.key !== r.key)
                                : [...selectedRows, r];
                              setSelectedRowKeys(nextKeys);
                              setSelectedRows(nextRows);
                            }}
                            renderCancel={renderCancelContract}
                            lawyersList={lawyersList}
                          />
                        ))}
                        <div
                          style={{
                            textAlign: "center",
                            color: "#888",
                            marginTop: 8,
                          }}
                        >
                          จำนวนสัญญาที่ค้นหาทั้งหมด {arrayTable.length} รายการ
                        </div>
                      </>
                    ) : (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "40px 20px",
                          color: "#888",
                        }}
                      >
                        {loading ? "กำลังค้นหาข้อมูล..." : "ไม่มีข้อมูลให้แสดง"}
                      </div>
                    )}
                  </Space>
                ) : (
                  <Table
                    style={{ marginTop: 10 }}
                    size="small"
                    columns={columns}
                    dataSource={arrayTable}
                    scroll={{ x: 900 }}
                    pagination={{
                      showSizeChanger: true,
                      showTotal: (total) => `ทั้งหมด ${total} รายการ`,
                    }}
                    locale={{
                      emptyText: loading
                        ? "กำลังค้นหาข้อมูล..."
                        : "ไม่มีข้อมูลให้แสดง",
                    }}
                    footer={() =>
                      arrayTable.length > 0 ? (
                        <div style={{ textAlign: "right", lineHeight: 1.6 }}>
                          <div>
                            จำนวนสัญญาที่ค้นหาทั้งหมด{" "}
                            {Number(arrayTable.length).toLocaleString("th-TH")}
                          </div>
                        </div>
                      ) : null
                    }
                  />
                )}
              </Col>
            </Row>
          </Card>
        )}
      </Spin>
    </div>
  );
};

const MainSumaryContno = MotionHoc(Main);
export default MainSumaryContno;
